import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';

export class NotificationModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: props.show
        };
    }

    close(callBack) {
        this.setState({
            showModal: false
        });
        this.props.onExited();
        if (callBack) {
            callBack();
        }
    }

    render() {
        const { header, instruction, icon, t } = this.props;

        const styles = {
            container: {
                minWidth: '380px'
            },
            base: {
                textAlign: 'center'
            },
            modalInstruction: {
                color: 'rgba(75, 85, 106, 0.9)',
                fontSize: '20px'
            },

            action: {
                margin: '0 5px',
                fontSize: '14px',
                minWidth: '150px',
                minHeight: '50px',
                width: 'initial',
                height: 'initial',
                backgroundColor: '#04b7db'
            }
        };

        const actions = this.props.actions ? this.props.actions.map((action, idx) => {
            const style = action.style || {};
            const className = action.className || '';
            return (<button
              key={idx}
              className={`btn ${className}`}
              style={{...styles.base, ...styles.action, ...style}}
              onClick={() => { this.close.call(this, action.onClick); }}
            >
                  {action.text}
            </button>);
        }) : <button className="btn btn-color-blue" style={{...styles.base, ...styles.action}} onClick={() => { this.close.call(this); }}>{t('button.gotit')}</button>;

        return (
            <Modal dialogClassName="modal-container" style={{...styles.container}} show={this.state.showModal}>
                <Modal.Header>
                    <div> {icon} </div>
                    <div className="headerTitle">{header}</div>
                    <i className="fa fa-times-circle float-right pointer close" onClick={() => { this.close.call(this); }} aria-hidden="true"></i>
                </Modal.Header>
                <Modal.Body>
                    <div className="modalInstruction" style={{...styles.base, ...styles.modalInstruction}}>
                        {instruction}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="modalActions" style={{...styles.base}}>
                        {actions}
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

/*
*   Modal Types
*   Alert, Notification
* */
NotificationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onExited: PropTypes.func,
    actions: PropTypes.array,
    t: PropTypes.func,
    modalType: PropTypes.string,
    icon: PropTypes.element,
    header: PropTypes.string,
    instruction: PropTypes.element.isRequired,
    style: PropTypes.object
};

export default translate(['translation'])(NotificationModal);



// WEBPACK FOOTER //
// ./src/components/SharedComponents/modal/notification-modal.js